// extracted by mini-css-extract-plugin
export default {"cls1":"UserListMenu-cls1__ZZ","cls2":"UserListMenu-cls2_sVo UserListMenu-cls1__ZZ"};